import { render, staticRenderFns } from "./ListModule.vue?vue&type=template&id=2fca58f7&scoped=true&"
import script from "./ListModule.vue?vue&type=script&lang=js&"
export * from "./ListModule.vue?vue&type=script&lang=js&"
import style0 from "./ListModule.vue?vue&type=style&index=0&id=2fca58f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca58f7",
  null
  
)

export default component.exports